import { createContext, useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { loginUser, logoutUser, demoLogin } from '../services/api.js';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUser(buildUser(decodedToken));
      } catch (error) {
        console.error("Invalid token:", error);
        setUser(null);
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password, captchaId = null, captchaCode = null) => {
    try {
      const response = await loginUser(username, password, captchaId, captchaCode);
      const decodedToken = jwtDecode(response.access);
      setUser(buildUser(decodedToken));
      history.push('/');
      return response;
    } catch (error) {
      throw error;
    }
  };

  const loginWithTokens = async (access, refresh) => {
    localStorage.setItem('access_token', access);
    localStorage.setItem('refresh_token', refresh);
    const decodedToken = jwtDecode(access);
    setUser(buildUser(decodedToken));
    history.push('/');
  };

  const loginDemo = async () => {
    const response = await demoLogin();
    const decodedToken = jwtDecode(response.access);
    setUser(buildUser(decodedToken));
    history.push('/');
    return response;
  };

  const logout = () => {
    logoutUser();
    setUser(null);
    history.push('/login');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginWithTokens, loginDemo, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

const buildUser = (decodedToken) => ({
  id: decodedToken.user_id,
  username: decodedToken.username,
  is_staff: decodedToken.is_staff,
  is_superuser: decodedToken.is_superuser,
  permissions: decodedToken.permissions || [],
  company_id: decodedToken.company_id,
  company_name: decodedToken.company_name,
  company_slug: decodedToken.company_slug,
  company_slug_en: decodedToken.company_slug_en,
  is_approved: decodedToken.is_approved,
  role: decodedToken.role,
});

export const useAuth = () => {
  return useContext(AuthContext);
};